import calculatorLabels from "@/constants/labels/calculators.labels.js";

export default {
    name: 'Dose',
    id: calculatorLabels.DOSE_CALCULATOR_ID,
    classes: ['Cálculo de Doses'],
    routeName: "dose-calculator",
    sections: [
        {
            "objects": [
                {
                    "objects": [
                        {
                            "objects": [],
                            "description": "Calcular a dose total a ser administrada ao paciente."
                        },
                        {
                            "objects": [],
                            "description": "Calcular o volume de medicamento a ser administrado ao paciente."
                        }
                    ]
                }
            ],
            "description": "Objetivos da Calculadora "
        },
        {
            "description": "Interpretação ",
            "objects": [
                {
                    "description": "Dose Total ",
                    "objects": [
                        {
                            "objects": [],
                            "description": "Informa a dose total a ser administrada ao paciente."
                        },
                        {
                            "description": "Dose Total = (Peso do Paciente) X (Dose por kg).",
                            "objects": []
                        }
                    ]
                },
                {
                    "objects": [
                        {
                            "objects": [],
                            "description": "Informa o volume total a ser administrado ao paciente."
                        },
                        {
                            "description": "Volume do Medicamento = (Dose Total)/(Concentração do Medicamento).",
                            "objects": []
                        },
                        {
                            "description": "O volume pode ser apresentado de duas formas:",
                            "objects": [
                                {
                                    "description": "Volume em mL | Quando a apresentação do medicamento for uma solução/líquido."
                                },
                                {
                                    "description": "Volume em unidades de apresentação | Quando a apresentação do medicamento for sólida (Comprimido, Cápsula, Tablete). "
                                }
                            ]
                        }
                    ],
                    "description": "Volume do Medicamento "
                }
            ]
        }
    ],
    references: [
        {
            "link": "Não se aplica",
            "level": "Não se aplica",
            "name": "Essential Calculations for Veterinary Nurses and Technicians, 3rd Edition",
            "magazine": "Livro",
            "year": "2016"
        },
        {
            "level": "Não se aplica",
            "magazine": "Livro",
            "name": "Medical Mathematics and Dosage Calculations for Veterinary Technicians, 3rd Edition",
            "link": "Não se aplica",
            "year": "2019"
        },
        {
            "name": "Henke's Med-Math: Dosage Calculation, Preparation, & Administration, 9th Edition",
            "level": "Não se aplica",
            "link": "Não se aplica",
            "magazine": "Livro",
            "year": "2019"
        }
    ]
}